import React, { Component } from "react";
import PropTypes from "prop-types";
import i18n from "i18n-react";
import { NavLink } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataHandler } from "C4";

const resetScrollPosition = () => window.scrollTo(0, 0);
const fancyOptions = {
  infobar: true,
  thumbs: {
    autoStart: true,
    axis: "y",
  },
  buttons: ["share", "close"],
  caption: "",
};

const NavButton = (props) => {
  const { text, icon, target, exact, appId, button } = props;

  return (
    <li className="button">
      <NavLink
        onClick={resetScrollPosition}
        activeClassName="is-active"
        exact={exact}
        to={target}
        className="link"
      >
        {i18n.translate(`nav.${text}`)}
        {icon && <FontAwesomeIcon icon={icon.replace("fa-", "").split(" ")} />}
      </NavLink>
    </li>
  );
};

export default class ButtonSet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
    });
  }

  render() {
    const { buttons, orientation } = this.props;
    const buttonElements = Object.values(buttons).map((button) => (
      <NavButton key={button.text} appId={this.state.appId} {...button} />
    ));

    return <ul className={orientation}>{buttonElements}</ul>;
  }
}

NavButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  target: PropTypes.string,
  exact: PropTypes.bool,
  appId: PropTypes.number,
  button: PropTypes.string,
};

NavButton.defaultProps = {
  appId: -1,
  text: "",
  icon: null,
  target: "/",
  exact: true,
  button: "",
};

ButtonSet.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  orientation: PropTypes.string,
};

ButtonSet.defaultProps = {
  buttons: {},
  orientation: "left",
};
